/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Preparing_AudioInputs */

const en_mobile_preparing_audio = /** @type {(inputs: Mobile_Preparing_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing audio …`)
};

const es_mobile_preparing_audio = /** @type {(inputs: Mobile_Preparing_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando audio …`)
};

/**
* | output |
* | --- |
* | "Preparing audio …" |
*
* @param {Mobile_Preparing_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_preparing_audio = /** @type {((inputs?: Mobile_Preparing_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Preparing_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_preparing_audio(inputs)
	return en_mobile_preparing_audio(inputs)
});